import { Controller } from "@hotwired/stimulus"

// Remembers the admin period selector across tabs via localStorage, without any
// redirect: on connect it rewrites the nav tab links to carry the stored period,
// so navigating between Dashboard/Registrations keeps the same window — only
// those two tabs are targets; the other pages ignore the period. Clicking a
// period stores it. "today" (the default) is never propagated.
export default class extends Controller {
  static targets = ["tab"]

  connect() {
    const stored = localStorage.getItem("wc_admin_period")
    if (!stored || stored === "today") return
    this.tabTargets.forEach(a => {
      const url = new URL(a.href, window.location.origin)
      url.searchParams.set("period", stored)
      a.href = url.pathname + url.search
    })
  }

  store(event) {
    localStorage.setItem("wc_admin_period", event.currentTarget.dataset.period)
  }
}
